import { ViewModel, View, ObservableArray } from "binder"
import { ProductionRestartManipulationView } from "./productionRestartManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { IProductionRestart } from "./IProductionRestart";
import { ProductionRestartEditorViewModel } from "./productionRestartEditor/productionRestartEditor-viewModel";
import moment from "moment";
import { TimePart, TimeSelectorViewModel } from "src/uicomponents/components/timeSelector/timeSelector-viewModel";

export class ProductionRestartManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'رفع توقفات';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.productionRestarts = ObservableArray.create<ProductionRestart>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductionRestartManipulationView();
    }
    public getTypeId(): string {
        return "VM-E5BC28CA-F804-4C88-A05D-8394B04B36B5"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set productionRestarts(v: ObservableArray<ProductionRestart>) { this._productionRestarts = v; } public get productionRestarts(): ObservableArray<ProductionRestart> { return this._productionRestarts; } private _productionRestarts: ObservableArray<ProductionRestart>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ProductionStopServices/ListAllProductionStops', {
                FilteringInformation: filteringInformation
            });
            this.productionRestarts.update(...result.ProductionStops.map((x, i) => {
                let p = new ProductionRestart(this);
                p.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                p.id = x.Id;
                p.from = x.From;
                p.until = x.Until;
                p.productLineName = x.ProductLineName;
                p.workStationName = x.WorkStationName;
                p.stopReasonName = x.StopReasonName;
                p.personnelName = x.PersonnelName;
                p.description = x.Description;
                const m = new TimePart(this);
                m.no = moment.utc(x.Until).minute();
                const h = new TimePart(this);
                h.no = moment.utc(x.Until).hour();
                p.timeSelector.selectedMinute = m;
                p.timeSelector.selectedHour = h;
                x.Type == 1 ? p.type = "باز" : x.Type == 2 ? p.type = "خاتمه یافته" : "";
                p.isOpen = x.Type == 1 ? true : x.Type == 2 ? false : p.isOpen;
                return p;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async showDetail(productionRestart: IProductionRestart) {
        let popup = new ProductionRestartEditorViewModel(this);
        await productionRestart.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }
}

export class ProductionRestart extends ViewModel implements IProductionRestart {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ProductionRestartManipulationViewModel) {
        super(parent);
        this._typedParent = parent;

        this.timeSelector = new TimeSelectorViewModel(this);
    }

    private _typedParent: ProductionRestartManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date; } private _date: moment.Moment;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from; } private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until; } private _until: moment.Moment;
    public set productLineName(v: string) { this._productLineName = v; } public get productLineName(): string { return this._productLineName; } private _productLineName: string;
    public set workStationName(v: string) { this._workStationName = v; } public get workStationName(): string { return this._workStationName; } private _workStationName: string;
    public set stopReasonName(v: string) { this._stopReasonName = v; } public get stopReasonName(): string { return this._stopReasonName; } private _stopReasonName: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName; } private _personnelName: string;
    public set type(v: string) { this._type = v; } public get type(): string { return this._type; } private _type: string;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description; } private _description: string;
    public set isOpen(v: boolean) { this._isOpen = v; } public get isOpen(): boolean { return this._isOpen; } private _isOpen: boolean;
    public set timeSelector(v: TimeSelectorViewModel) { this._timeSelector = v; } public get timeSelector(): TimeSelectorViewModel { return this._timeSelector; } private _timeSelector: TimeSelectorViewModel;

    async cloneTo(productionRestart: IProductionRestart) {
        productionRestart.id = this.id;
        productionRestart.date = this.date;
        productionRestart.from = this.from;
        productionRestart.until = this.until;
        productionRestart.productLineName = this.productLineName;
        productionRestart.workStationName = this.workStationName;
        productionRestart.stopReasonName = this.stopReasonName;
        productionRestart.personnelName = this.personnelName;
        productionRestart.type = this.type;
        productionRestart.description = this.description;
        productionRestart.isOpen = this.isOpen;
        productionRestart.timeSelector = new TimeSelectorViewModel(this);
        const m = new TimePart(this);
        m.no = 10;
        const h = new TimePart(this);
        h.no = 20;
        productionRestart.timeSelector.selectedMinute = m;
        productionRestart.timeSelector.selectedHour = h;
    }

    async showDetail() {
        this._typedParent.showDetail(this);
    }
}
